import React, { useEffect, useState } from 'react';
import { motion } from "framer-motion";
import { GiTreeBranch, GiMeditation, GiHeartBeats } from 'react-icons/gi';
import '../../styles/AboutSerene1.css';
import ContactPopup from "../ContactPopup";

const AboutWoods = () => {
    const [openPopup, setOpenPopup] = useState(false);
    const [isMobileTablet, setIsMobileTablet] = useState(
        typeof window !== "undefined" ? window.innerWidth <= 991 : false
    );

    useEffect(() => {
        const onResize = () => setIsMobileTablet(window.innerWidth <= 991);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    const fadeUp = {
        hidden: { opacity: 0, y: 45, filter: "blur(10px)" },
        show: {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            transition: { duration: 0.9, ease: "easeOut" },
        },
    };

    const infoBlocks = [
        {
            icon: <GiHeartBeats className="feature-icon" size={isMobileTablet ? 52 : 40} />,
            title: "Refined Way of Living",
            body: (
                <p
                    className={`text-muted small mb-0 lh-lg ${isMobileTablet ? "text-start" : "text-center"}`}
                    style={isMobileTablet ? { fontSize: "clamp(0.9rem, 4.2vw, 1.1rem)", lineHeight: 1.6 } : undefined}
                >
                    Living is easy at VESSELLA WOODS. As a villa development designed to offer an unequalled lifestyle, Vessella WOODS ensures that life goes on uninterrupted. A slew of services assure stress-free living, from smart home technologies right down to thoughtful little features like smoke alarms.
                </p>
            ),
        },
        // {
        //     icon: <GiMeditation className="feature-icon" size={isMobileTablet ? 52 : 40} />,
        //     title: "Key Highlights",
        //     body: (
        //         <div
        //             className={`d-flex flex-column gap-1 ${isMobileTablet ? "mt-1" : "mt-3"}`}
        //             style={isMobileTablet ? { fontSize: "clamp(0.9rem, 4.2vw, 1.1rem)", lineHeight: 1.5 } : undefined}
        //         >
        //             <span className="fw-semibold text-secondary">72 Luxury Villas</span>
        //             <span className="fw-semibold text-secondary">8.71 Acres of Green Space</span>
        //             <span className="fw-semibold text-secondary">3 & 4 BHK units</span>
        //             <span className="fw-semibold text-secondary">Kismatpur Location</span>
        //         </div>
        //     ),
        // },
        {
            icon: <GiTreeBranch className="feature-icon" size={isMobileTablet ? 52 : 40} />,
            title: " Location Defined by Calm",
            body: (
                <p
                    className={`text-muted small mb-0 lh-lg ${isMobileTablet ? "text-start" : "text-center"}`}
                    style={isMobileTablet ? { fontSize: "clamp(0.9rem, 4.2vw, 1.1rem)", lineHeight: 1.6 } : undefined}
                >
                    Empowers the residents to have a great lifestyle with its quick access to essential needs, urban amenities, entertainment, educational institutions and shopping malls. Vessella Woods away from all the rugged locations and it is the only place that opens its arms unconditionally at the end of a long day.
                </p>
            ),
        },
    ];

    return (
        <>
            <section
                className={`about-serene-section container-fluid ${isMobileTablet ? "about-serene-mobile" : ""}`}
                id="about-serene"
            >
                <div
                    className={`container position-relative d-flex flex-column ${isMobileTablet ? "justify-content-start about-serene-mobile-container" : " justify-content-center pb-5"}`}
                >


                    <div
                        className={`green-text-part col-lg-5 col-md-7 h-100 ${isMobileTablet ? "mobile-hero-panel" : ""}`}
                    >
                        <div
                            className={`green-branding-box text-white ${isMobileTablet ? "mobile-branding-box" : "p-5"}`}
                        >
                            {/* Header Text */}
                            <div className="mb-4">
                                <h1
                                    className={`display-3 mb-2 font-serif ${isMobileTablet ? "mobile-hero-title" : ""}`}
                                >
                                    About <br /> Meadows Living
                                </h1>
                                <p
                                    className={`fst-italic fs-3 fw-light text-white-50 mb-2${isMobileTablet ? "mobile-hero-subtitle" : ""}`}
                                    style={{ fontFamily: "cursive" }}
                                >
                                    72 Luxury Villas
                                </p>
                                <p
                                    className={`fst-italic fs-3 fw-light text-white-50 mb-2${isMobileTablet ? "mobile-hero-subtitle" : ""}`}
                                    style={{ fontFamily: "cursive" }}
                                >
                                    8.71 Acres of Green Space
                                </p>
                                <p
                                    className={`fst-italic fs-3 fw-light text-white-50 mb-2${isMobileTablet ? "mobile-hero-subtitle" : ""}`}
                                    style={{ fontFamily: "cursive" }}
                                >
                                    3 & 4 BHK units
                                </p>
                                <p
                                    className={`fst-italic fs-3 fw-light text-white-50 mb-2${isMobileTablet ? "mobile-hero-subtitle" : ""}`}
                                    style={{ fontFamily: "cursive" }}
                                >
                                    Narsingi Location
                                </p>

                            </div>

                            <motion.a
                                onClick={() => setOpenPopup(true)}
                                className="location-btn d-inline-flex align-items-center px-4 py-2"
                                variants={fadeUp}
                                initial="hidden"
                                whileInView="show"
                                viewport={{ once: true, amount: 0.6 }}
                                whileHover={{ scale: 1.04 }}
                                whileTap={{ scale: 0.96 }}
                                style={{ color: "#fff", border: "1px solid rgba(255,255,255,0.72)", textDecoration: "none", borderRadius: "0" }}
                            >
                                <span className={`text-uppercase small letter-spacing-2 me-2 ${isMobileTablet ? "mobile-hero-cta-text" : ""}`}>Explore Our Community</span>
                                <i className={`fa-solid fa-arrow-right ${isMobileTablet ? "mobile-hero-cta-icon" : ""}`}></i>
                            </motion.a>
                            <ContactPopup open={openPopup} onClose={() => setOpenPopup(false)} />
                        </div>
                    </div>


                    {/* Main Info Card */}
                    <div
                        className={`main-info-card glass-panel shadow-lg mt-auto ${isMobileTablet ? "mobile-info-card" : "p-5"}`}
                    >
                        <div className='row align-items-center'>
                            {infoBlocks.map((item, index) => (
                                <div
                                    key={item.title}
                                    className={`col-lg-6 px-4 mb-4 mb-lg-0 ${!isMobileTablet && index < 2 ? "border-end-lg" : ""} ${isMobileTablet ? "mobile-info-block d-flex align-items-start" : "text-center"}`}
                                >
                                    <div className={`${isMobileTablet ? "flex-shrink-0" : "mb-3"}`}>
                                        {item.icon}
                                    </div>
                                    <div className={`${isMobileTablet ? "flex-grow-1" : ""}`}>
                                        <h5
                                            className={`mb-2 fw-bold text-dark ${isMobileTablet ? "mobile-info-title text-start" : ""}`}
                                        >
                                            {item.title}
                                        </h5>
                                        {item.body}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
            </section>
        </>
    );
};

export default AboutWoods;
